import { default as teacherPositionCategory } from './position-category/routes'
import { default as activityOfferedComponent } from './activity-offered-component/routes'
import { default as activityOfferedModality } from './activity-offered-modality/routes'
import { default as activityOffered } from './activity-offered/routes'

export default [
    ...teacherPositionCategory,
    ...activityOfferedComponent,
    ...activityOfferedModality,
    ...activityOffered
]